import React from 'react';
import './YearsMap.scss';
import ChartMap from './ChartMap';
import colors from "../../../../../../../../apps/baykis-pl/pattern-lab/_data/generated-colors.json";
import ChartMapLegend from "./ChartMapLegend";

const YearsMap =  ({ size, shapePath, shape, data, latLonData, colorConfig, apiParameter, freshData }) => {
  const years = apiParameter[5];
  return (
    <>
      <div className="vis-wrapper years-map-wrapper" id="vis-wrapper">
        {data.map((mapData, index) => (
          <ChartMap
            size={size}
            colorConfig={colorConfig}
            data={mapData}
            shape={shape}
            shapePath={shapePath}
            latLonData={latLonData}
            caption={{ firstLine: years[index].label, secondLine: '' }}
            key={years[index].label}
            backdrop={false}
            showLegend={false}
            showCopyright={index === 0}
          />
        ))}
      </div>
      <div className={'years-map_legend'}>
        <ChartMapLegend colorConfig={colorConfig} colors={colors} />
      </div>
    </>
  );
};

function areEqual(prevProps, nextProps) {
  if(!nextProps.freshData || (prevProps.apiParameter === nextProps.apiParameter && prevProps.years === nextProps.years)) {
    return true;
  }
  return false;
}
export default React.memo(YearsMap, areEqual);
